import * as Types from "../types";

export const storeTaskList = (data, dispatch) =>
  dispatch({ type: Types.STORE_TASK_LIST, payload: data });
